import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Link from 'Component/Link';
import { scrollToTop } from 'Util/Helper';

import { MAX_EXCERPT_LENGTH } from './CmsBanner.config';

import './CmsBanner.style';

/**
 * CMS Banner component
 * @class CmsBanner
 * @namespace Pwa/Component/Cms/CmsBanner/Component/CmsBannerComponent */
export class CmsBannerComponent extends PureComponent {
    static propTypes = {
        header: PropTypes.string,
        body: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ]),
        linkText: PropTypes.string,
        linkUrl: PropTypes.string,
        desktopImage: PropTypes.string.isRequired,
        mobileImage: PropTypes.string.isRequired,
        imageAlt: PropTypes.string
    };

    static defaultProps = {
        header: '',
        body: '',
        linkText: '',
        linkUrl: '',
        imageAlt: 'CMS Banner'
    };

    handleScrollToTop = () => {
        scrollToTop();
    };

    renderBodyContent() {
        const { body } = this.props;

        if (!body) {
            return null;
        }

        if (Array.isArray(body)) {
            // Use content hash as part of key instead of just index
            return body.map((paragraph) => {
                const contentHash = paragraph.trim().substring(0, MAX_EXCERPT_LENGTH);
                return (
                    <p key={ `paragraph-${contentHash}` }>{ paragraph }</p>
                );
            });
        }

        return <p>{ body }</p>;
    }

    render() {
        const {
            header,
            linkText,
            linkUrl,
            desktopImage,
            mobileImage,
            imageAlt
        } = this.props;

        return (
            <div className="container">
                <div className="cms-banner">
                    <picture>
                        <source media="(min-width: 768px)" srcSet={ desktopImage } />
                        <source media="(max-width: 767px)" srcSet={ mobileImage } />
                        <img src={ desktopImage } alt={ imageAlt } loading="lazy" />
                    </picture>
                    <div className="cms-banner-content">
                        <div className="cms-banner-text">
                            { header && <h2>{ header }</h2> }
                            { this.renderBodyContent() }
                        </div>
                        { linkText && linkUrl && (
                            <Link
                              to={ linkUrl }
                              className="btn btn-primary"
                              onClick={ this.handleScrollToTop }
                            >
                                { linkText }
                            </Link>
                        ) }
                    </div>
                </div>
            </div>
        );
    }
}

export default CmsBannerComponent;
